import * as React from "react";
const SVGComponentFooterRockHand = (props) => (
  <svg
    viewBox="0 0 22 18"
    fill="none"
    {...props}
  >
    <g id="873b77b2">
      <g id="1818ff60">
        <path
          id="58e1af59"
          d="M8 12L14 6"
          stroke="#222B63"
          strokeWidth={1.5}
          strokeLinecap="round"
        />
        <path
          id="234481da"
          d="M14.5 11.5C14.5 12.0523 14.0523 12.5 13.5 12.5C12.9477 12.5 12.5 12.0523 12.5 11.5C12.5 10.9477 12.9477 10.5 13.5 10.5C14.0523 10.5 14.5 10.9477 14.5 11.5Z"
          fill="#785AF0"
        />
        <path
          id="9cd0076d"
          d="M9.5 6.5C9.5 7.0523 9.0523 7.5 8.5 7.5C7.94772 7.5 7.5 7.0523 7.5 6.5C7.5 5.94772 7.94772 5.5 8.5 5.5C9.0523 5.5 9.5 5.94772 9.5 6.5Z"
          fill="#222B63"
        />
        <path
          id="ee0b9216"
          d="M14 2H9.99384C6.21679 2 4.32827 2 3.1549 2.9481C2.27653 3.65783 2.05569 4.69137 2.00016 6.44642C1.99304 6.67143 2.22114 6.85123 2.49061 6.90831C3.35033 7.09031 3.9846 7.72234 3.9846 8.47406C3.9846 9.22578 3.35033 9.85781 2.49061 10.0398C2.22114 10.0969 1.99304 10.2767 2.00016 10.5017C2.05569 12.2568 2.27653 13.2903 3.1549 14"
          stroke="#785AF0"
          strokeLinecap="round"
        />
        <path
          id="abe35e0b"
          d="M16 2C17.3086 2.10411 18.1885 2.34024 18.8448 2.87581C19.7234 3.59288 19.9443 4.63711 19.9998 6.41033C20.007 6.63766 19.7788 6.81933 19.5092 6.877C18.6493 7.06088 18.0148 7.69945 18.0148 8.45895C18.0148 9.21845 18.6493 9.85702 19.5092 10.0409C19.7788 10.0985 20.007 10.2802 19.9998 10.5076C19.9443 12.2808 19.7234 13.325 18.8448 14.0421C17.671 15 15.7819 15 12.0037 15H7.99631C6.82865 15 5.84143 15 5 14.9717"
          stroke="#222B63"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);
export default SVGComponentFooterRockHand;
